import React from 'react';

import Header from '../../components/header';
import Footer from '../../components/footer';
import Cards from '../../components/cards';
import imgMac from '../../assets/apple.svg';
import imgWindows from '../../assets/janelas.svg';
import './styles.css';

export default function Options() {
  return (
    <>
      <Header content="Escolha uma das opções abaixo" />
      <div className="options-container">
        <Cards
          imgCard1={imgWindows}
          spanCard1="Windows"
          linkCard1="/renew"
          imgCard2={imgMac}
          spanCard2="Linux / MacOS"
          linkCard2="/systems"
        />
      </div>
      <Footer />
    </>
  );
}
